export default "__VITE_ASSET__BPjhOO3e__";